import { useHttp } from '@/composable/service/useHttp';
import fcShopDonetworkHttp from '@/services/http/fcShop.donetwork.http';
import { FcShopConfig } from '@/domain/fcShop.entity';
import useGetHopes from '@/composable/controller/hope/useGetMyHopes';
import useAsyncState from '@/composable/service/useAsyncState';
import * as _ from 'radash';
import { computed, watch } from 'vue';
import {useShopConfigStore} from "@/store/shopConfig.store";

export default function useGetShopConfig() {
  const http = useHttp(fcShopDonetworkHttp.getFcShopConfig);
  const { setShopConfigs } = useShopConfigStore();
  const { hopes } = useGetHopes();

  async function requestConfigs(ids: number[]) {
    return http.request({ fcShopId: ids });
  }

  async function getFcShopConfig() {
    const shopIds = _.unique((hopes.value).map((h) => h.fcShop.id));
    const res = await http.request({ fcShopId: shopIds });
    return res;
  }
  const state = useAsyncState(getFcShopConfig, { default: [] as FcShopConfig[] });

  watch(hopes, async () => {
    const res = await state.request();
    setShopConfigs(res.map((item) => ({ shopId: item.fcShopId, hasOnlineReserveForm: item.hasOnlineReserveForm })));
  });

  return {
    requestConfigs,
    shopConfigs: state.data,
    isOnlineInquiryAvailable: computed(() => state.data.value.some((item) => item.hasOnlineReserveForm)),
    loading: state.loading,
    error: http.error,
  };
}
